module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"label-location":"Standort","label-factory-nr":"Fab. Nr.","label-construction-year":"BJ"},"fr":{"label-construction-year":"Année de construction","label-factory-nr":"N° de fabr.","label-location":"Emplacement"},"it":{"label-construction-year":"Anno costr","label-factory-nr":"No.fabbr.","label-location":"Luogo/posizione"}}')
  delete Component.options._Ctor
}
